import { create } from "zustand";
import { verifyRequest } from "./authService";

type AdminRole = "admin" | "billing_viewer" | "san_admin" | "san_retailer_viewer";

type AuthStore = {
  isVerified: boolean;
  adminRole?: AdminRole;
  verifyLogin: () => Promise<boolean>;
  setAdminRole: (role: AdminRole) => void;
  isSanRole: () => boolean;
  isSanAdminRole: () => boolean;
};

export const useAuthStore = create<AuthStore>((set, get) => ({
  isVerified: false,
  adminRole: undefined,
  verifyLogin: async () => {
    const response = await verifyRequest();
    set({ isVerified: true, adminRole: response.role });

    return true;
  },
  setAdminRole: (role: AdminRole) => {
    set({ adminRole: role });
  },
  isSanRole: () => {
    const adminRole = get().adminRole;
    return isSanRole(adminRole);
  },
  isSanAdminRole: () => {
    const adminRole = get().adminRole;
    return isSanAdminRole(adminRole);
  },
}));

// 純粋関数としてもエクスポート（スキーマ定義などで使用）
export const isSanAdminRole = (adminRole?: AdminRole): boolean => {
  return adminRole === 'san_admin';
};

// 純粋関数としてもエクスポート（スキーマ定義などで使用）
export const isSanRole = (adminRole?: AdminRole): boolean => {
  return adminRole === 'san_admin' || adminRole === 'san_retailer_viewer';
};
